module.exports = "/packs/thumbnail_trial_lesson-5a81818530b14f9e697939e02a792134.jpg";